/*! LUVA gummies purchase picker – size + Autoship / one-time */
(function () {
  function money(cents, format) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var whole = String(Math.round(cents) / 100);
    if (Math.round(cents) % 100 === 0) whole = String(Math.round(cents) / 100);
    var fmt = format || 'AED {{amount}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/Dhs\.\s*/g, 'AED ');
  }

  function aed(n, decimals) {
    var d = decimals == null ? 0 : decimals;
    var v = Number(n);
    if (!isFinite(v)) return 'AED —';
    if (d === 0) return 'AED ' + Math.round(v);
    return 'AED ' + v.toFixed(d);
  }

  function perDay(n) {
    var v = Number(n);
    var t = luvaT('gummies_purchase_per_day', 'AED __PRICE__/day');
    if (!t || t.indexOf('__PRICE__') === -1) t = 'AED __PRICE__/day';
    return t.replace('__PRICE__', isFinite(v) ? v.toFixed(2) : '—');
  }

  function boot(root) {
    var sizes = Array.prototype.slice.call(root.querySelectorAll('[data-luva-size]'));
    if (!sizes.length) return;
    var form = root.querySelector('[data-luva-gp-form]');
    var idField = form && form.querySelector('[data-luva-idfield]');
    var planField = form && form.querySelector('[data-luva-selling-plan]');
    var cta = root.querySelector('[data-luva-gp-cta]');
    var onetimeBtn = root.querySelector('[data-luva-onetime]');
    var prelaunch = root.getAttribute('data-prelaunch') === '1';
    var hasPlans = root.getAttribute('data-has-plans') === 'true';
    var moneyFormat = root.getAttribute('data-money-format') || 'AED {{amount}}';
    var mode = 'subscribe'; // subscribe | onetime
    var selected = sizes.find(function (b) { return b.classList.contains('is-selected'); }) || sizes.find(function (b) { return b.getAttribute('data-months') === '3'; }) || sizes[0];

    function selectSize(btn) {
      sizes.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      selected = btn;
      if (idField) idField.value = btn.getAttribute('data-variant-id');
      sync();
    }

    function sync() {
      if (!selected) return;
      var months = selected.getAttribute('data-months');
      var servings = selected.getAttribute('data-servings');
      var tinsText = months + (months === '1' ? luvaT('gummies_purchase_tin', ' tin') : luvaT('gummies_purchase_tins', ' tins')) + (servings ? ' · ' + servings + luvaT('gummies_purchase_servings', ' servings') : '');
      var pct = selected.getAttribute('data-pct');
      var save = selected.getAttribute('data-save');
      var label = selected.getAttribute('data-label');
      var oneTime = parseInt(selected.getAttribute('data-one-time'), 10);
      var subCents = parseInt(selected.getAttribute('data-sub-cents'), 10);
      var subDisplay = parseInt(selected.getAttribute('data-sub-display'), 10);
      var perDaySub = selected.getAttribute('data-per-day-sub');
      var perDayOne = selected.getAttribute('data-per-day-one');

      sizes.forEach(function (b) {
        var dayEl = b.querySelector('[data-luva-size-day]');
        if (!dayEl) return;
        var d = mode === 'subscribe' ? b.getAttribute('data-per-day-sub') : b.getAttribute('data-per-day-one');
        dayEl.textContent = perDay(d);
      });

      var pctEl = root.querySelector('[data-luva-pct]');
      if (pctEl) pctEl.textContent = pct;
      var sum = root.querySelector('[data-luva-shipsum]');
      if (sum) {
        sum.textContent =
          label + ' · ' + tinsText + ' · ' + perDay(mode === 'subscribe' ? perDaySub : perDayOne);
      }
      var strike = root.querySelector('[data-luva-strike]');
      var price = root.querySelector('[data-luva-price]');
      var yousave = root.querySelector('[data-luva-yousave]');
      var popular = root.querySelector('[data-luva-popular]');

      if (mode === 'subscribe') {
        if (strike) {
          strike.hidden = false;
          strike.textContent = aed(oneTime / 100, 0);
        }
        if (price) price.textContent = aed(subDisplay, 0);
        if (yousave) {
          yousave.hidden = false;
          yousave.textContent = luvaT('gummies_purchase_you_save', 'You save AED {amount}').replace('{amount}', save);
        }
      } else {
        if (strike) strike.hidden = true;
        if (price) price.textContent = aed(oneTime / 100, 0);
        if (yousave) yousave.hidden = true;
      }

      if (popular) {
        popular.hidden = months !== '3';
      }

      var otPrice = root.querySelector('[data-luva-onetime-price]');
      var otDay = root.querySelector('[data-luva-onetime-day]');
      if (otPrice) otPrice.textContent = aed(oneTime / 100, 0);
      if (otDay) otDay.textContent = 'AED ' + Number(perDayOne).toFixed(2);

      if (cta) {
        cta.setAttribute('data-mode', mode);
        if (prelaunch) {
          /* 2026-10-16: never disabled before launch. A disabled <button> swallows the tap
             (iOS Safari), so "Notify me" did nothing. It stays type="button" (no cart
             submit); assets/luva-notify.js opens the email signup on tap. */
          cta.disabled = false;
          cta.type = 'button';
          cta.setAttribute('data-luva-notify-cta', '');
          cta.setAttribute('aria-haspopup', 'dialog');
          cta.textContent = luvaT('gummies_purchase_coming_soon', 'Coming Soon · Notify me');
        } else if (mode === 'subscribe') {
          if (hasPlans) {
            cta.disabled = false;
            cta.textContent = luvaT('gummies_purchase_add_autoship', 'Add Autoship to cart');
            if (planField) {
              // Prefer a plan whose name/options mention the month count
              var planId = matchPlan(months);
              if (planId) {
                planField.disabled = false;
                planField.value = planId;
              } else {
                planField.disabled = true;
                planField.value = '';
              }
            }
          } else {
            // UI ready but no subscriptions app — keep CTA informative, do not fake checkout
            cta.disabled = true;
            cta.textContent = luvaT('gummies_purchase_autoship_install', 'Autoship · Install subscriptions app');
            if (planField) {
              planField.disabled = true;
              planField.value = '';
            }
          }
        } else {
          cta.disabled = false;
          cta.textContent = luvaT('gummies_purchase_add_to_cart', 'Add to cart');
          if (planField) {
            planField.disabled = true;
            planField.value = '';
          }
        }
      }

      // Sticky bar price if present
      var barPrice = document.querySelector('[data-luva-bar] .luva-pdp__bart i');
      if (barPrice) {
        barPrice.textContent = mode === 'subscribe' ? aed(subDisplay, 0) : aed(oneTime / 100, 0);
      }
    }

    function matchPlan(months) {
      var node = root.querySelector('[data-luva-gp-plans]');
      if (!node) return '';
      try {
        var map = JSON.parse(node.textContent || '{}');
        var keys = Object.keys(map);
        var hit = keys.find(function (id) {
          var n = JSON.stringify(map[id]).toLowerCase();
          return n.indexOf(months + ' month') !== -1 || n.indexOf('every ' + months) !== -1;
        });
        return hit || keys[0] || '';
      } catch (e) {
        return '';
      }
    }

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () { selectSize(btn); });
    });

    if (onetimeBtn) {
      onetimeBtn.addEventListener('click', function () {
        if (mode === 'onetime') {
          mode = 'subscribe';
          onetimeBtn.setAttribute('aria-pressed', 'false');
        } else {
          mode = 'onetime';
          onetimeBtn.setAttribute('aria-pressed', 'true');
        }
        sync();
      });
    }

    function goNotify(e) {
      if (e) e.preventDefault();
      if (window.LuvaNotify) { window.LuvaNotify.open(cta); return; }
      var target = document.querySelector('#luva-notify, a[data-luva-notify], [data-luva-notify], footer form[action*="contact"]');
      if (target) {
        if (target.matches && target.matches('a[href^="#"]')) {
          var id = target.getAttribute('href');
          var el = id ? document.querySelector(id) : null;
          (el || target).scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
    if (cta && prelaunch) {
      cta.addEventListener('click', goNotify);
    }
    root.querySelectorAll('[data-luva-notify-cta]').forEach(function (el) {
      el.addEventListener('click', goNotify);
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-luva-gp]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
